import * as THREE from 'three';
import { AssetManager } from './engine/Assets';
import { initHUD, PPE_ITEMS } from './ui/hud';
import { App } from './engine/App';
import './ui/store';
import { showWipModalIfNeeded } from './ui/wipModal';

async function bootstrap() {
  console.log('Bootstrapping LogSim3D...');

  // Initialize UI Bindings
  initHUD();

  // Load all assets before starting the engine
  const ppeModelUrls = PPE_ITEMS
    .flatMap(item => item.models?.map(m => m.modelPath) || [])
    .filter((path): path is string => !!path);
  await AssetManager.loadAll(ppeModelUrls);

  // Hide loading screen
  const loadingScreen = document.getElementById('loading-screen');
  if (loadingScreen) {
    loadingScreen.classList.remove('active');
    setTimeout(() => {
      loadingScreen.style.display = 'none';
    }, 500); // match CSS transition duration
  }

  console.log('Initializing 3D Engine & Physics Worker...');
  const app = new App('app-canvas');
  app.init();

  // Start the render and physics loop
  app.run();
  
  // Bind Scenario Buttons
  const scenarioButtons = document.querySelectorAll('.scenario-group .glass-btn, [data-scenario]');
  scenarioButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      const scenario = (e.currentTarget as HTMLElement).getAttribute('data-scenario');
      if (scenario) {
        app.loadScenario(`/assets/scenarios/${scenario}`);
      }
    });
  });

  // Bind Custom Scenario Upload
  const customUploadInput = document.getElementById('custom-json') as HTMLInputElement;
  customUploadInput?.addEventListener('change', () => {
    const file = customUploadInput.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const scenarioText = event.target?.result as string;
        const scenario = JSON.parse(scenarioText);
        app.loadScenarioObj(scenario);
      } catch (err) {
        console.error('Failed to parse custom scenario JSON:', err);
        alert('Invalid scenario JSON file format.');
      }
    };
    reader.readAsText(file);
    // Reset file input value to allow uploading the same file again
    customUploadInput.value = '';
  });
  showWipModalIfNeeded();
  
  console.log('Simulation ready. Log dropping...');
}

bootstrap().catch(console.error);
